(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vasenia-booties-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vasenia-booties-guide')) {
    customElements.define('vasenia-booties-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        const chapters = this.querySelector('.vbg__chapter-disclosure');
        const mobile = window.matchMedia('(max-width: 800px)');
        this.mobileChaptersOpen = window.location.hash === '#booties-steps';
        this.syncChapters = () => {
          chapters.open = !mobile.matches || this.mobileChaptersOpen;
        };
        this.syncChapters();
        mobile.addEventListener('change', this.syncChapters);
        this.chapterMedia = mobile;
        chapters.addEventListener('toggle', () => {
          if (mobile.matches) this.mobileChaptersOpen = chapters.open;
        });
        this.addEventListener('click', (event) => {
          const jump = event.target.closest('a[href="#booties-steps"]');
          if (jump && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
            event.preventDefault();
            chapters.open = true;
            this.mobileChaptersOpen = true;
            const target = this.querySelector(mobile.matches ? '.vbg__chapter-toggle' : '#booties-steps-title');
            target.scrollIntoView({behavior: 'auto', block: 'start'});
            target.focus({preventScroll: true});
            return;
          }
          const link = event.target.closest('a[data-video-time]');
          if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const frame = this.querySelector('iframe');
          const seconds = Number(link.dataset.videoTime);
          const videoId = this.dataset.videoId;
          if (!frame || !Number.isFinite(seconds) || seconds < 0 || !/^[\w-]{11}$/.test(videoId)) return;
          event.preventDefault();
          frame.src = 'https://www.youtube-nocookie.com/embed/' + videoId + '?rel=0&playsinline=1&autoplay=1&start=' + seconds;
          this.querySelectorAll('.vbg__chapters a').forEach(item => item.removeAttribute('aria-current'));
          if (link.closest('.vbg__chapters')) link.setAttribute('aria-current', 'step');
          this.querySelector('.vbg__playing').textContent = 'Selected step: ' + link.dataset.stepLabel;
          const heading = this.querySelector('#booties-watch-title');
          heading.scrollIntoView({behavior: 'auto', block: 'start'});
          heading.focus({preventScroll: true});
        });
      }
      disconnectedCallback() {
        if (this.chapterMedia && this.syncChapters) this.chapterMedia.removeEventListener('change', this.syncChapters);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vasenia-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vasenia-newsletter-popup')) {
    customElements.define('vasenia-newsletter-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abortController = new AbortController();
        this.panel = this.querySelector('[role="region"]');
        this.teaser = this.querySelector('[data-signup-teaser]');
        this.form = this.querySelector('form');
        this.email = this.querySelector('input[type="email"]');
        this.storageKey = 'vasenia:signup:20261008';
        this.pendingKey = `${this.storageKey}:pending`;
        this.delay = Math.max(0, Number(this.dataset.delay) || 20) * 1000;
        this.cooldown = Math.max(1, Number(this.dataset.frequencyDays) || 7) * 86400000;
        const signal = this.abortController.signal;
        this.teaser.addEventListener('click', () => this.open(true), { signal });
        this.querySelectorAll('[data-signup-close]').forEach((button) => {
          button.addEventListener('click', () => this.close(), { signal });
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !this.panel.hidden) this.close();
        }, { signal });
        this.form.addEventListener('submit', () => {
          this.writeStorage('sessionStorage', this.pendingKey, {
            formId: this.dataset.formId,
            path: window.location.pathname,
            submittedAt: Date.now()
          });
        }, { signal });
        const pending = this.readStorage('sessionStorage', this.pendingKey);
        const ownAnchor = window.location.hash === `#${this.dataset.formId}`;
        const freshPending = pending && pending.formId === this.dataset.formId && pending.path === window.location.pathname && Date.now() - pending.submittedAt >= 0 && Date.now() - pending.submittedAt < 1800000;
        const ownReturn = ownAnchor && freshPending;
        const serverSuccess = this.querySelector('[data-signup-server-success]');
        const serverError = this.querySelector('[data-signup-error]');
        if (ownAnchor && !freshPending) {
          this.querySelector('[data-signup-unconfirmed]').hidden = false;
          this.open(true);
          return;
        }
        if (ownReturn && serverSuccess) {
          this.confirmed = true;
          this.querySelector('[data-signup-fields]').hidden = true;
          serverSuccess.hidden = false;
          this.writeStorage('localStorage', this.storageKey, { subscribed: true, shownAt: Date.now() });
          this.removeStorage('sessionStorage', this.pendingKey);
          this.open(false);
          this.querySelector('[data-signup-success-heading]').focus({ preventScroll: true });
          return;
        }
        if (ownReturn) {
          if (serverError) {
            serverError.hidden = false;
            this.email.setAttribute('aria-invalid', 'true');
            this.email.setAttribute('aria-describedby', `${this.id}-consent ${this.id}-error`);
          } else {
            this.querySelector('[data-signup-unconfirmed]').hidden = false;
          }
          this.removeStorage('sessionStorage', this.pendingKey);
          this.open(true);
          return;
        }
        const state = this.readStorage('localStorage', this.storageKey);
        if (this.dataset.subscriber === 'true' || (state && state.subscribed)) return;
        if (this.dataset.designMode === 'true') {
          this.open(false);
          return;
        }
        if (state && Date.now() - state.shownAt < this.cooldown) {
          this.teaser.hidden = false;
          return;
        }
        this.timer = window.setTimeout(() => this.autoOpen(), this.delay);
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        this.abortController?.abort();
        this.initialized = false;
      }

      autoOpen() {
        if (!this.isConnected) return;
        const blockingPrompt = [...document.querySelectorAll('dialog[open], [aria-modal="true"]:not([hidden]), #shopify-pc__banner')].some((element) => {
          if (element.closest('details:not([open]), [hidden]') || !element.getClientRects().length) return false;
          for (let node = element; node; node = node.parentElement) {
            const style = getComputedStyle(node);
            if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
          }
          return true;
        });
        if (document.hidden || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]') || blockingPrompt) {
          this.timer = window.setTimeout(() => this.autoOpen(), 5000);
          return;
        }
        this.open(false);
      }

      open(focusHeading) {
        window.clearTimeout(this.timer);
        this.panel.hidden = false;
        this.teaser.hidden = true;
        this.teaser.setAttribute('aria-expanded', 'true');
        if (!this.confirmed && this.dataset.designMode !== 'true') {
          this.writeStorage('localStorage', this.storageKey, { ...(this.readStorage('localStorage', this.storageKey) || {}), shownAt: Date.now() });
        }
        if (focusHeading) this.querySelector('[data-signup-heading]').focus({ preventScroll: true });
      }

      close() {
        const restoreFocus = this.panel.contains(document.activeElement);
        this.panel.hidden = true;
        this.teaser.hidden = Boolean(this.confirmed);
        this.teaser.setAttribute('aria-expanded', 'false');
        if (!this.confirmed) {
          if (this.dataset.designMode !== 'true') this.writeStorage('localStorage', this.storageKey, { ...(this.readStorage('localStorage', this.storageKey) || {}), shownAt: Date.now() });
          if (restoreFocus) this.teaser.focus({ preventScroll: true });
        } else if (restoreFocus) {
          document.activeElement.blur();
        }
      }

      readStorage(type, key) {
        try { return JSON.parse(window[type].getItem(key) || 'null'); } catch { return null; }
      }

      writeStorage(type, key, value) {
        try { window[type].setItem(key, JSON.stringify(value)); } catch {}
      }

      removeStorage(type, key) {
        try { window[type].removeItem(key); } catch {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vasenia-slippers-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vasenia-slippers-guide')) {
    customElements.define('vasenia-slippers-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        const chapters = this.querySelector('.vbg__chapter-disclosure');
        const mobile = window.matchMedia('(max-width: 800px)');
        this.mobileChaptersOpen = window.location.hash === '#slippers-steps';
        this.syncChapters = () => {
          chapters.open = !mobile.matches || this.mobileChaptersOpen;
        };
        this.syncChapters();
        mobile.addEventListener('change', this.syncChapters);
        this.chapterMedia = mobile;
        chapters.addEventListener('toggle', () => {
          if (mobile.matches) this.mobileChaptersOpen = chapters.open;
        });
        this.addEventListener('click', (event) => {
          const jump = event.target.closest('a[href="#slippers-steps"]');
          if (jump && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
            event.preventDefault();
            chapters.open = true;
            this.mobileChaptersOpen = true;
            const target = this.querySelector(mobile.matches ? '.vbg__chapter-toggle' : '#slippers-steps-title');
            target.scrollIntoView({behavior: 'auto', block: 'start'});
            target.focus({preventScroll: true});
            return;
          }
          const link = event.target.closest('a[data-video-time]');
          if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const frame = this.querySelector('iframe');
          const seconds = Number(link.dataset.videoTime);
          const videoId = this.dataset.videoId;
          if (!frame || !Number.isFinite(seconds) || seconds < 0 || !/^[\w-]{11}$/.test(videoId)) return;
          event.preventDefault();
          frame.src = 'https://www.youtube-nocookie.com/embed/' + videoId + '?rel=0&playsinline=1&autoplay=1&start=' + seconds;
          this.querySelectorAll('.vbg__chapters a').forEach(item => item.removeAttribute('aria-current'));
          if (link.closest('.vbg__chapters')) link.setAttribute('aria-current', 'step');
          this.querySelector('.vbg__playing').textContent = this.dataset.selectedLabel + link.dataset.stepLabel;
          const heading = this.querySelector('#slippers-watch-title');
          heading.scrollIntoView({behavior: 'auto', block: 'start'});
          heading.focus({preventScroll: true});
        });
      }
      disconnectedCallback() {
        if (this.chapterMedia && this.syncChapters) this.chapterMedia.removeEventListener('change', this.syncChapters);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
